import React from 'react';
import MainMenuComponent from '../../Components/Menus/MainMenuComponent';

function ManagementScorePage() {
  return <MainMenuComponent menuName="score-board" />;
}

export default ManagementScorePage;
